"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../common/helpers/time");
var AdminCoursesController = /** @class */ (function () {
    function AdminCoursesController($q, $state, CoursesModel, courseTypes, LocationsModel, UsersModel, ClassroomsModel, VueStoreFactory) {
        var _this = this;
        this.$q = $q;
        this.$state = $state;
        this.maxSize = 10;
        this.currentPage = 1;
        this.loading = true;
        this.CoursesModel = CoursesModel;
        this.LocationsModel = LocationsModel;
        this.UsersModel = UsersModel;
        this.ClassroomsModel = ClassroomsModel;
        this.VueStoreFactory = VueStoreFactory;
        this.pageChanged = this.pageChanged.bind(this);
        this.search = this.search.bind(this);
        this.getCourses = this.getCourses.bind(this);
        this.getClassrooms = this.getClassrooms.bind(this);
        this.getInstructors = this.getInstructors.bind(this);
        this.updateStartDate = this.updateStartDate.bind(this);
        this.updateEndDate = this.updateEndDate.bind(this);
        this.viewCourse = this.viewCourse.bind(this);
        this.courseTypeOptions = courseTypes;
        this.courseTypeOptions.unshift({ name: "All" });
        this.instructors = [];
        this.classrooms = [];
        this.locations = [];
        this.searchData = {
            paginate: true,
            end_date: "",
            start_date: "",
            page: 1,
        };
        this.setup()
            .then(function (res) {
            _this.loading = false;
        })
            .catch(function (Error) {
            _this.loading = false;
        });
    }
    AdminCoursesController.prototype.setup = function () {
        var _this = this;
        var courses = this.getCourses();
        var locations = this.LocationsModel.getLocations();
        var classrooms = this.getClassrooms(null, true);
        var instructors = this.getInstructors(null, true);
        return this.$q
            .all([courses, locations, classrooms, instructors])
            .then(function (responses) {
            _this.locations = responses[1];
            _this.locations.unshift({ name: "All" });
        });
    };
    AdminCoursesController.prototype.viewCourse = function (course) {
        var _this = this;
        // This makes sure that when viewing a single course from this screen, the first classdate is selected
        if (course.classes.length > 0) {
            var data = {
                id: course.id,
                date: course.date,
                class_id: course.classes[0].id,
                start: (0, time_1.dateTimeStringToDate)(course.classes[0].start).toLocaleTimeString("en-US", { hour: "numeric", minute: "numeric" }),
                end: (0, time_1.dateTimeStringToDate)(course.classes[0].end).toLocaleTimeString("en-US", { hour: "numeric", minute: "numeric" }),
            };
            data.date = (0, time_1.dateStringToDate)(course.date).toLocaleDateString();
            this.VueStoreFactory.dispatch("SET_VIEW_COURSE", data).then(function (response) {
                _this.$state.go("drivecoach.admin.courses.view", {
                    courseId: course.id,
                });
            });
        }
        else {
            var data = {
                id: course.id,
                date: course.date,
                class_id: 0,
                start: (0, time_1.timeStringToDate)(course.time).toLocaleTimeString("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                }),
                end: (0, time_1.addMinutes)((0, time_1.timeStringToDate)(course.time), parseInt(course.duration, 10)).toLocaleTimeString("en-US", { hour: "numeric", minute: "numeric" }),
            };
            data.date = (0, time_1.dateStringToDate)(course.date).toLocaleDateString();
            this.VueStoreFactory.dispatch("SET_VIEW_COURSE", data).then(function (response) {
                _this.$state.go("drivecoach.admin.courses.view", {
                    courseId: course.id,
                });
            });
        }
    };
    AdminCoursesController.prototype.getCourses = function () {
        var _this = this;
        return this.CoursesModel.get().then(function (response) {
            _this.courses = response.courses.data.map(_this.formatCourses);
            _this.totalItems = response.courses.total;
        });
    };
    AdminCoursesController.prototype.pageChanged = function () {
        var _this = this;
        this.searchData.page = this.currentPage;
        var params = Object.fromEntries(Object.entries(this.searchData).filter(function (_a) {
            var key = _a[0], value = _a[1];
            return value != null && value !== '';
        }));
        return this.CoursesModel.search(params).then(function (response) {
            _this.courses = response.courses.data.map(_this.formatCourses);
            _this.totalItems = response.courses.total;
        });
    };
    AdminCoursesController.prototype.formatCourses = function (course) {
        var timeDate = (0, time_1.timeStringToDate)(course.time);
        course.time = (0, time_1.formatDateTime)(timeDate, "h:mm A");
        course.end = (0, time_1.formatDateTime)((0, time_1.addMinutes)(timeDate, parseInt(course.duration, 10)), "h:mm A");
        return course;
    };
    AdminCoursesController.prototype.search = function () {
        var _this = this;
        this.loading = true;
        this.searchData.page = 1;
        var params = Object.fromEntries(Object.entries(this.searchData).filter(function (_a) {
            var key = _a[0], value = _a[1];
            return value != null && value !== '';
        }));
        return this.CoursesModel.search(params)
            .then(function (response) {
            _this.courses = response.courses.data.map(_this.formatCourses);
            _this.totalItems = response.courses.total;
            _this.currentPage = 1;
            _this.loading = false;
        })
            .catch(function (Error) {
            _this.loading = false;
        });
    };
    AdminCoursesController.prototype.getInstructors = function (name, all, location) {
        var _this = this;
        if (name === void 0) { name = null; }
        if (all === void 0) { all = false; }
        if (location === void 0) { location = null; }
        if (name === null && all === false) {
            return;
        }
        this.loading = true;
        var params = {
            overrideInstructorSettings: this.overrideInstructorSettings,
        };
        return this.UsersModel.searchInstructors(params)
            .then(function (response) {
            _this.instructors = response.instructors;
            _this.instructors.unshift({ fullname: "All" });
            _this.loading = false;
            return response.instructors;
        })
            .catch(function (error) {
            _this.loading = false;
            return error;
        });
    };
    AdminCoursesController.prototype.getClassrooms = function (name, all, location) {
        var _this = this;
        if (name === void 0) { name = null; }
        if (all === void 0) { all = false; }
        if (location === void 0) { location = null; }
        this.busy = true;
        return this.ClassroomsModel.search({})
            .then(function (response) {
            _this.classrooms = response.classrooms;
            _this.classrooms.unshift({ name: "All" });
            _this.loading = false;
            return response.classrooms;
        })
            .catch(function (error) {
            _this.loading = false;
            return error;
        });
    };
    AdminCoursesController.prototype.updateEndDate = function (newDate) {
        this.searchData.end_date = newDate.selected[0];
    };
    AdminCoursesController.prototype.updateStartDate = function (newDate) {
        this.searchData.start_date = newDate.selected[0];
    };
    return AdminCoursesController;
}());
AdminCoursesController.$inject = [
    "$q",
    "$state",
    "CoursesModel",
    "courseTypes",
    "LocationsModel",
    "UsersModel",
    "ClassroomsModel",
    "VueStoreFactory",
];
exports.default = AdminCoursesController;
